export default __webpack_public_path__ + "static/media/BasicPublic1.07a41f88.png";